import { createContext } from "react";

export const AnchorContext = createContext<string>("");
